import axios from 'axios'
import i18n from '@/i18n/config'
import { useAuthStore } from '@/stores/authStore'

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:4545/api'

let refreshPromise: Promise<string | null> | null = null

function resolveApiLanguage(): string {
  const currentLanguage = i18n.language || 'ru'
  const normalizedLanguage = currentLanguage.split('-')[0].toLowerCase()

  return ['ru', 'en'].includes(normalizedLanguage) ? normalizedLanguage : 'ru'
}

/**
 * Единая точка обновления JWT (dedupe для interceptor и bootstrap).
 * Возвращает новый token или null при неудаче / если refresh недоступен.
 */
export async function refreshAccessToken(): Promise<string | null> {
  const { token, isImpersonating } = useAuthStore.getState()

  // rememberMe не блокирует silent refresh: access JWT живёт ~JWT_TTL минут,
  // иначе учитель выкидывается на логин каждые ~60 мин (Telegram support T-006).
  if (!token || isImpersonating) {
    return null
  }

  if (!refreshPromise) {
    refreshPromise = axios
      .post<{
        success?: boolean
        data?: { token: string; expires_in: number }
      }>(
        `${API_URL}/auth/refresh`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'Accept-Language': resolveApiLanguage(),
          },
        },
      )
      .then((response) => {
        const payload = response.data?.data
        if (!response.data?.success || !payload?.token) {
          return null
        }
        useAuthStore.getState().updateToken(payload.token, payload.expires_in)
        return payload.token
      })
      .catch(() => null)
      .finally(() => {
        refreshPromise = null
      })
  }

  return refreshPromise
}
